import React from "react";
import { Select, Form } from "antd";
import { Controller } from "react-hook-form";
import { getError } from "../../../utils/form";
/* 
const itemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    lg: { span: 9 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
}; */

function itemLayout(fullLabelWidth) {
  let layout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
      lg: { span: 10 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
      lg: { span: 14 },
    },
  };

  if (fullLabelWidth === true) {
    layout.labelCol.lg.span = 24;
    // layout.wrapperCol.lg.span = 24;
  }

  return layout;
}

const ControlledSelect = ({
  control,
  errors,
  name,
  label,
  required,
  fullLabelWidth = false,
  options,
  disabled = false,
  multiple = false,
  customChange,
  loading = false,
}) => {
  const error = getError({ errors, name });

    const handleChange = (val, onChange) => {
    onChange(val);
    if (customChange) {
      customChange(val);
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Form.Item
          label={label}
          //   {...itemLayout}
          {...itemLayout(fullLabelWidth)}
          required={required}
          labelAlign="left"
          validateStatus={error ? "error" : "success"}
          help={error?.message}
        >
          <Select
            mode={multiple ? "multiple" : null}
            {...field}
            style={{ width: "100%" }}
            showSearch
            optionFilterProp="label"
            filterOption={(input, option) =>
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={(val) => handleChange(val, field.onChange)}
            disabled={disabled}
            loading={loading}
            placeholder={loading ? "Loading..." : undefined}
            /*    onFocus={() => {
              let el = document.getElementsByName(name);
              el = el[0].children[0].children[0].children[0];
              el.setAttribute("autocomplete", "autocomplete_off");
              el.setAttribute("id", `${label}_`);
            }} */
            options={options}
          />
        </Form.Item>
      )}
    />
  );
};

export default ControlledSelect;
